import { Field, Float, Int, ObjectType } from '@nestjs/graphql'
import { NotificationDto } from '../notifications'

@ObjectType()
export class ArcModelStatsDto {
  @Field(type => Float, { nullable: true })
  averageRating?: number

  @Field(type => Int, { nullable: true })
  delayedClaimed?: number

  @Field(type => Int, { nullable: true })
  newReviewCount?: number

  @Field(type => Int, { nullable: true })
  newReviewActivityCount?: number

  @Field(type => NotificationDto, { nullable: true })
  nextNotification?: NotificationDto

  @Field(type => Int, { nullable: true })
  reviewCount?: number

  @Field(type => Int, { nullable: true })
  cancelledCount?: number
}
